module.exports = __webpack_public_path__ + "static/media/es-ct.44b55695.svg";